import { hotelsSearchState, HotelsSearchState } from './Hotels/search';
import { hotelsState, HotelsState } from './Hotels/hotels';
import { hotelsOrdersState, HotelsOrdersState } from './Hotels/orders';
import { hotelsCurrencyState, HotelsCurrenciesState } from './Hotels/currency';

import { airports, AirportsState } from './Flight/airports';
import { airDates, AirDatesState } from './Flight/airDates';
import { passengers, PassengerState } from './Flight/passengers';
import { fares, FaresState } from './Flight/fares';
import { awadOrders, AwadOrdersState } from './Flight/awadOrders';
import { flightCurrency, FlightCurrenciesState } from './Flight/currency';

import { restaurants, RestaurantsState } from './Food/restaurants';
import { foodOrder, FoodOrderState } from './Food/order';

import { compilationAfisha, CompilationAfishaState } from './Afisha/compilation';
import { eventsAfisha, EventsAfishaState } from './Afisha/events';
import { filtersAfisha, FiltersAfishaState } from './Afisha/filters';
import { scheduleAfisha, ScheduleAfishaState } from './Afisha/schedule';
import { dateAfisha, DateAfishaState } from './Afisha/date';

import { legalState, LegalState } from './Legal/legal';
import { legalDiscussionState, LegalDiscussionState } from './Legal/discussion';

import { medicineDiscussionState, MedicineDiscussionState } from './Medicine/discussion';

import { discussionsState, DiscussionsState } from './Discussions/discussions';

import { accountingState, AccountingState } from './Accounting/accounting';
import { accountingDiscussionState, AccountingDiscussionState } from './Accounting/discussion';

import { customFlowers, CustomFlowersState } from './CustomFlowers/customFlowers';

import { TransferState, transfer } from './Transfer/transfer';

import { userState, UserState } from './user';

import { RegistrationState, registrationState } from './Registration/registration';
import { AuthorizationState, authorizationState } from './Authorization/authorization';

import { RequestsState, requestsState } from './Requests/requests';

import { ServicesState, servicesState } from './Services/services';

import { benefitsState, BenefitsState } from './Benefits/benefits';
import { rubricsState, RubricsState } from './Benefits/rubrics';
import { DeliveryState, deliveryState } from './Delivery/delivery';
import { cleaningState, CleaningState } from './Cleaning/cleaning';
import { profileState, ProfileState } from './profile';
import { ChatsState, chatsState } from './chats';
import { searchParams, SearchParamsState } from './Flight/searchParams';
import { openedCountriesState, OpenedCountriesState } from './OpenedCountries/openedCountries';
import { childrenState, ChildrenState } from './Discussions/children';
import { promocodesState, PromocodesState } from './Promocodes/promocodes';

export interface AppState {
    hotelsSearchState: HotelsSearchState;
    hotelsState: HotelsState;
    hotelsOrdersState: HotelsOrdersState;
    hotelsCurrencyState: HotelsCurrenciesState;

    airports: AirportsState;
    airDates: AirDatesState;
    searchParams: SearchParamsState;
    passengers: PassengerState;
    fares: FaresState;
    awadOrders: AwadOrdersState;
    restaurants: RestaurantsState;
    foodOrder: FoodOrderState;
    compilationAfisha: CompilationAfishaState;
    eventsAfisha: EventsAfishaState;
    filtersAfisha: FiltersAfishaState;
    scheduleAfisha: ScheduleAfishaState;
    dateAfisha: DateAfishaState;
    legalState: LegalState;
    legalDiscussionState: LegalDiscussionState;
    medicineDiscussionState: MedicineDiscussionState;
    discussionsState: DiscussionsState;
    accountingState: AccountingState;
    accountingDiscussionState: AccountingDiscussionState;
    customFlowers: CustomFlowersState;
    transfer: TransferState;
    flightCurrency: FlightCurrenciesState;

    userState: UserState;

    registrationState: RegistrationState;
    authorizationState: AuthorizationState;

    requestsState: RequestsState;

    servicesState: ServicesState;
    profileState: ProfileState;

    benefitsState: BenefitsState;
    rubricsState: RubricsState;

    deliveryState: DeliveryState;
    cleaningState: CleaningState;

    chatsState: ChatsState;

    openedCountriesState: OpenedCountriesState;
    promocodesState: PromocodesState;

    childrenState: ChildrenState;
}

export const reducers = {
    hotelsSearchState,
    hotelsState,
    hotelsOrdersState,
    hotelsCurrencyState,

    airports,
    airDates,
    searchParams,
    passengers,
    fares,
    userState,
    awadOrders,
    restaurants,
    foodOrder,
    compilationAfisha,
    eventsAfisha,
    filtersAfisha,
    scheduleAfisha,
    dateAfisha,
    legalState,
    legalDiscussionState,
    medicineDiscussionState,
    discussionsState,
    accountingState,
    accountingDiscussionState,
    customFlowers,
    transfer,
    flightCurrency,
    registrationState,
    authorizationState,
    requestsState,
    servicesState,
    profileState,
    benefitsState,
    rubricsState,
    deliveryState,
    cleaningState,
    chatsState,
    openedCountriesState,
    promocodesState,
    childrenState,
};



// WEBPACK FOOTER //
// ./src/reducers/index.ts